// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"4236c1d3","211":"a88043c9","247":"d65dae7d","368":"a88043c9","391":"a88043c9","664":"a88043c9","697":"a88043c9","934":"a88043c9"}[chunkId] + ".chunk.css";
};